export default __webpack_public_path__ + "static/media/IMG_4669.46cf9836.JPG";